import { ClientDataConstants } from './clientData.constants'
import { IClientDataAction, IClientDataState } from './clientData.types'

export const initialclientDataState: IClientDataState = {
  clientDataImportError: null,
}

export function clientDataReducer(
  state: IClientDataState = initialclientDataState,
  action: IClientDataAction
): IClientDataState {
  switch (action.type) {
    case ClientDataConstants.SET_CLIENT_DATA_IMPORT_ERROR:
      return { ...state, clientDataImportError: action.clientDataImportError }
    default:
      return state
  }
}
